import { render } from "./GPTView.vue?vue&type=template&id=163948d4"
import script from "./GPTView.vue?vue&type=script&lang=js"
export * from "./GPTView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__